var _defineProperty = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _CN, _JP;
module.exports = {
  messages: {
    CN: (_CN = {
      'designCategory2.new': '新 建',
      'designCategory2.remind': '温馨提示',
      'designCategory2.remindcontent': '右侧一级分类列表可以拖动排序',
      'designCategory2.serialnumber': '序号',
      'designCategory2.classificationname': '分类名称',
      'designCategory2.classifityType': '分类类型',
      'designCategory2.updatetime': '更新时间',
      'designCategory2.operation': '操作',
      'designCategory2.edit': '编辑',
      'designCategory2.delete': '删除',
      'designCategory2.newclassification': '新建分类',
      'designCategory2.editclassification': '编辑一级分类',
      'designCategory2.editclassification2': '编辑二级分类',
      'designCategory2.parentclassification': '父级分类',
      'designCategory2.categoryname': '显示名称',
      'designCategory2.selectclassificationname': '请选择父级分类',
      'designCategory2.classifiedpictures': '分类图片',
      'designCategory2.uploadpictures': '上传图片',
      'designCategory2.suerdelete': '确定要删除吗？',
      'designCategory2.determine': '确定',
      'designCategory2.cancel': '取消',
      'designCategory2.translate': '翻译',
      'designCategory2.chinesetypeface': '简体',
      'designCategory2.categorynameprop': '请输入',
      'designCategory2.addfirstcategory': '新建一级分类',
      'designCategory2.showflag': '前台显示',
      'designCategory2.showflagprop': '用于PC端是否显示',
      'designCategory2.display': '显示',
      'designCategory2.nodisplay': '不显示',
      "designCategory2.tipsForUploadingPicture": "建议上传1:1比例、分辨率为 {size} 的图片。上传图片大小不能超过 {uploadLimit} MB",
      'designCategory2.oldPlace': '原产地',
      'designCategory2.transportWay': '运输方式',
      'designCategory2.brand': '品牌',
      'designCategory2.permalink': '全部商品',
      'designCategory2.goodsClassifity': '商品分类',
      'designCategory2.myselfDefine': '自定义',
      'designCategory2.classifity': '分类',
      'designCategory2.link': '链接',
      'designCategory2.sourceName': '原产地名称',
      'designCategory2.sourceAreaImg': '原产地图片'
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CN, "designCategory2.transportWay", '运输方式'), 'designCategory2.transportImg', '运输方式图片'), 'designCategory2.bindName', '品牌名称'), 'designCategory2.bindImg', '品牌图片'), 'designCategory2.classifityName', '商品分类名称'), 'designCategory2.classifityImg', '商品分类图片'), 'designCategory2.defineName', '自定义分类名称'), 'designCategory2.defineImg', '自定义分类图片'), 'designCategory2.addsecondcategory', '新建二级分类'), 'designCategory2.linkContent', '全部商品类型下没有二级分类'), _defineProperty(_defineProperty(_defineProperty(_CN, 'designCategory2.type', '类型'), 'designCategory2.goodsNum', '商品数量'), 'designCategory2.allClifity', '所有分类')),
    JP: (_JP = {
      'designCategory2.new': '新規 作成',
      'designCategory2.remind': 'ヒント',
      'designCategory2.remindcontent': '右側のカテゴリー1はドラッグして順序を変更できます',
      'designCategory2.serialnumber': '番号',
      'designCategory2.classificationname': 'カテゴリー名',
      'designCategory2.classifityType': 'カテゴリータイプ',
      'designCategory2.updatetime': '更新時間',
      'designCategory2.operation': '操作',
      'designCategory2.edit': '編集',
      'designCategory2.delete': '削除',
      'designCategory2.newclassification': '新規カテゴリ',
      'designCategory2.editclassification': 'カテゴリー1を編集',
      'designCategory2.editclassification2': 'カテゴリー2を編集',
      'designCategory2.parentclassification': '親カテゴリ',
      'designCategory2.categoryname': '表示名',
      'designCategory2.selectclassificationname': '请选择父级分类',
      'designCategory2.classifiedpictures': 'カテゴリー画像',
      'designCategory2.uploadpictures': '画像をアップロード',
      'designCategory2.suerdelete': '削除してもよろしいですか？',
      'designCategory2.determine': '確定',
      'designCategory2.cancel': 'キャンセル',
      'designCategory2.translate': '翻訳',
      'designCategory2.chinesetypeface': '简体',
      'designCategory2.categorynameprop': '入力してください',
      'designCategory2.addfirstcategory': 'カテゴリー1を新規',
      'designCategory2.showflag': '前台显示',
      'designCategory2.showflagprop': '用于PC端是否显示',
      'designCategory2.display': '表示',
      'designCategory2.nodisplay': '不显示',
      "designCategory2.tipsForUploadingPicture": "1:1の比率、解像度が{size}の画像をアップロードすることをお勧めします。アップロードする画像のサイズは{uploadLimit}MBを超えてはいけません",
      'designCategory2.oldPlace': '原産地',
      'designCategory2.transportWay': '配達方法',
      'designCategory2.brand': 'ブランド',
      'designCategory2.permalink': '全商品',
      'designCategory2.goodsClassifity': '商品カテゴリー',
      'designCategory2.myselfDefine': 'カスタムカテゴリー',
      'designCategory2.classifity': 'カテゴリー',
      'designCategory2.link': 'リンク',
      'designCategory2.sourceName': '原産地名',
      'designCategory2.sourceAreaImg': '原産地画像'
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JP, "designCategory2.transportWay", '配達方法'), 'designCategory2.transportImg', '配達方法画像'), 'designCategory2.bindName', 'ブランド名'), 'designCategory2.bindImg', 'ブランド画像'), 'designCategory2.classifityName', '商品カテゴリー名'), 'designCategory2.classifityImg', '商品カテゴリー画像'), 'designCategory2.defineName', 'カスタムカテゴリー名'), 'designCategory2.defineImg', 'カスタムカテゴリー画像'), 'designCategory2.addsecondcategory', 'カテゴリー2を新規'), 'designCategory2.linkContent', '全商品タイプに二次カテゴリーはありません'), _defineProperty(_defineProperty(_defineProperty(_JP, 'designCategory2.type', 'タイプ'), 'designCategory2.goodsNum', '商品数量'), 'designCategory2.allClifity', '全カテゴリー'))
  }
};